import type { LoadoutSlotKey } from "../../hooks/use-current-loadout.ts";

export interface SlotDef {
	slotKey: LoadoutSlotKey;
	label: string;
	stratagemIndex?: number;
}

export const SLOT_DEFS: SlotDef[] = [
	{ slotKey: "primary", label: "PRIMARY" },
	{ slotKey: "secondary", label: "SECONDARY" },
	{ slotKey: "grenade", label: "GRENADE" },
	{ slotKey: "armor", label: "ARMOR" },
	{ slotKey: "stratagems", label: "STRAT 1", stratagemIndex: 0 },
	{ slotKey: "stratagems", label: "STRAT 2", stratagemIndex: 1 },
	{ slotKey: "stratagems", label: "STRAT 3", stratagemIndex: 2 },
	{ slotKey: "stratagems", label: "STRAT 4", stratagemIndex: 3 },
	{ slotKey: "booster", label: "BOOSTER" },
];
